<template>
  <el-dialog
    title="数据导出"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="exportForm" class="qcFrom" :model="formData" :rules="rules" label-width="100px">
      <!-- 按任务编号导出 -->
      <el-form-item label="导出类型" prop="exportType">
        <el-radio-group v-model="exportType">
          <el-radio label="taskId">按任务编号导出</el-radio>
          <el-radio label="time" :disabled="formData.dataType === 2">按时间导出</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="数据类型" prop="dataType">
        <el-radio-group v-model="formData.dataType">
          <el-radio :label="1">常规影像检查</el-radio>
          <el-radio :label="2" :disabled="exportType === 'time'">核医学影像检查</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="任务编号" prop="taskId" v-if="exportType === 'taskId'">
        <el-input v-model="formData.taskId" placeholder="请输入任务编号" />
      </el-form-item>

      <el-form-item label="创建时间" prop="selectedMonth" v-if="exportType === 'time'">
        <el-date-picker
          style="width: 200px"
          v-model="formData.selectedMonth"
          type="month"
          placeholder="请选择月份"
          format="yyyy年MM月"
          value-format="yyyy-MM"
          @change="handleDateChange"
        />
      </el-form-item>

      <el-form-item label="任务类型" prop="sampleType" v-if="exportType === 'time'">
        <el-select v-model="formData.sampleType" placeholder="请选择" style="width: 100%">
          <el-option label="影像" :value="1" />
          <el-option label="报告" :value="2" />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleExport" :loading="loading">导出</el-button>
    </div>
   
  </el-dialog>
</template>

<script>
import Api from '@/api/index.js'
import axios from '@/js/api'

export default {
  name: 'ExportTaskData',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exportType: 'taskId', // 导出类型：taskId 或 time
      loading: false,
      formData: {
        taskId: '',
        selectedMonth: '',
        startDt: '',
        endDt: '',
        sampleType: 1,
        dataType: 1
      },
      rules: {
        taskId: [
          { required: true, message: '请输入任务编号', trigger: 'blur' }
        ],
        selectedMonth: [
          { required: true, message: '请选择创建时间', trigger: 'change' }
        ],
        sampleType: [
          { required: true, message: '请选择任务类型', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    exportType(newVal) {
      // 切换导出类型时清空对应的验证
      this.$nextTick(() => {
        if (newVal === 'taskId') {
          this.$refs.exportForm.clearValidate(['selectedMonth'])
          this.formData.selectedMonth = ''
          this.formData.startDt = ''
          this.formData.endDt = ''
        } else {
          this.$refs.exportForm.clearValidate(['taskId'])
          this.formData.taskId = ''
        }
      })
    }
  },
  methods: {
    handleDateChange(value) {
      if (value) {
        // 设置月份的第一天
        this.formData.startDt = value + '-01'
        
        // 获取该月份的最后一天
        const year = parseInt(value.split('-')[0])
        const month = parseInt(value.split('-')[1])
        const lastDay = new Date(year, month, 0).getDate()
        this.formData.endDt = value + '-' + String(lastDay).padStart(2, '0')
      } else {
        this.formData.startDt = ''
        this.formData.endDt = ''
      }
    },
    
    handleExport() {
      this.$refs.exportForm.validate((valid) => {
        if (valid) {
          this.loading = true
          
          // 构建请求参数
          const params = {
            sampleType: this.formData.sampleType
          }
          
          if (this.exportType === 'taskId') {
            params.taskId = this.formData.taskId
          } else {
            params.startDt = this.formData.startDt
            params.endDt = this.formData.endDt
          }
          if(this.formData.dataType === 1) {
            this.exportData(params)
          } else {
            this.nuclearMedicineExport(params)
          }
        }
      })
    },
    
    exportData(params) {
      try {
        let exportSuffixUrl = this.exportType === 'taskId' ? `?taskId=${params.taskId}`: `?startDt=${params.startDt}&endDt=${params.endDt}&sampleType=${params.sampleType}`
        const exportUrl = axios.exportExcel(Api.api.manager.ExportSampleTaskAsync) + exportSuffixUrl
        window.open(exportUrl)
        
        this.$message.success('导出任务已提交')
        this.handleClose()
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请重试')
      } finally {
        this.loading = false
      }
    },
    nuclearMedicineExport(params) {
      try {
        const exportUrl = axios.exportExcel(Api.api.manager.ExportPetScoreDeductionDetailsById) + `?id=${params.taskId}`
        window.open(exportUrl)
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请重试')
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.resetForm()
      this.$emit('update:visible', false)
    },
    
    resetForm() {
      this.exportType = 'taskId'
      this.formData = {
        taskId: '',
        selectedMonth: '',
        startDt: '',
        endDt: '',
        sampleType: 1
      }
      this.loading = false
      this.$refs.exportForm && this.$refs.exportForm.resetFields()
    }
  }
}
</script>

<style scoped>
.tip-message {
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  padding: 8px 16px;
  margin-top: 10px;
}

.tip-text {
  color: #e6a23c;
  font-size: 14px;
}

.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 20px;
}
::v-deep.el-radio__input.is-disabled + span.el-radio__label{
  font-size: 14px;
}
</style>
